import React from 'react';
import strings from '../../lang/strings.js';
import { PageSettings } from "../../config/page-settings";
import { withRouter } from 'react-router-dom';
import { inject } from 'mobx-react';
import { Panel, PanelBody, PanelHeader } from '../../components/panel/panel.jsx';
import DataTable from './../../components/content/data-table.jsx';
import SearchInput from './../../components/content/search-input.js';
import SearchSelect from './../../components/content/search-select.js';
import ManagerEditPopup from './manager-edit-popup'
import $ from 'jquery';
import './../../config/util';
import Const from './../../config/const';
const queryString = require('query-string');

class Manager extends React.Component {
    static contextType = PageSettings;

    constructor(props) {
        super(props);

        let searchQS = queryString.parse(this.props.location.search);

        this.state = {
            search_info: searchQS,
            selected_manager_id: null,
            show_manager_popup: false,
        };

        this.refreshTable = this.refreshTable.bind(this);
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.location.search != this.props.location.search) {
            let searchQS = queryString.parse(this.props.location.search);
            this.setState({ search_info: searchQS }, () => this.refreshTable());
        }
    }

    refreshTable = (refresh) => {
        this.tblMember.draw(refresh);
    };

    searchTable = () => {
        let searchQS = queryString.parse(this.props.location.search);
        Object.assign(searchQS, this.state.search_info)
        const new_query = queryString.stringify(searchQS);
        if (new_query == this.props.location.search.substr(1)) {
            this.refreshTable();
        } else {
            this.props.history.push('?' + new_query);
        }
    }

    showManagerDetailPopup(id) {
        this.setState({
            show_manager_popup: true,
            selected_manager_id: id
        });
    }

    deleteManager(id) {
        let self = this;
        this.context.showConfirm(strings.confirm_delete_title, function (response) {
            if (response) {
                self.context.post('manager/delete', { id }, function () {
                    self.context.addNotification('success', strings.alert_title, strings.confirm_delete_done);
                    self.refreshTable(false);
                }, true);
            }
        });
    }

    render() {
        let self = this;
        let columnNo = 0;

        const { search_info } = this.state;

        return (
            <div>
                <Panel>
                    <PanelHeader noButton={true}>{strings.manager_list}</PanelHeader>
                    <PanelBody>
                        <div>
                            <ManagerEditPopup isOpen={this.state.show_manager_popup} manager_id={this.state.selected_manager_id} onClose={() => {
                                this.setState({ show_manager_popup: false });
                            }} onSave={() => {
                                this.setState({ show_manager_popup: false });
                                this.refreshTable(false);
                            }} />
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-horizontal form-inline'>
                                        <SearchSelect
                                            data={[
                                                { code: 'user_id', name: strings.user_id },
                                                { code: 'nickname', name: strings.nickname },
                                            ]}
                                            value={search_info.column || 'user_id'}
                                            onChange={(value) => {
                                                this.setState({
                                                    search_info: {
                                                        ...search_info,
                                                        column: value,
                                                        start: 0,
                                                    }
                                                }, this.searchTable);
                                            }}
                                        />
                                        <SearchInput
                                            value={search_info.keyword}
                                            onChange={(value) => {
                                                this.setState({
                                                    search_info: {
                                                        ...search_info,
                                                        keyword: value,
                                                        column: search_info.column || 'user_id',
                                                        start: 0,
                                                    }
                                                })
                                            }}
                                            handler={(value) => this.searchTable()}
                                        />
                                        <button type='button' className='btn btn-success btn-sm ml-md-2' onClick={() => this.searchTable()}>{strings.search}</button>
                                        <button type='button' className='btn btn-danger btn-sm ml-md-2' onClick={() => {
                                            self.showManagerDetailPopup(null);
                                        }}>{strings.add}</button>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12 mt-3'>
                                    <DataTable ref={(ref) => this.tblMember = ref}
                                        customPaginate={true}
                                        initialPage={search_info.start || 0}
                                        onPageChange={(value) => {
                                            this.setState({
                                                search_info: {
                                                    ...search_info,
                                                    start: value,
                                                }
                                            }, this.searchTable);
                                        }}
                                        options={{
                                            columnDefs: [
                                                {
                                                    targets: [columnNo++], data: 'id', orderable: false,
                                                    render: function (value) {
                                                        return value;
                                                    }
                                                },
                                                {
                                                    targets: [columnNo++], data: 'user_id', orderable: false,
                                                    render: function (value) {
                                                        return value;
                                                    }
                                                },
                                                {
                                                    targets: [columnNo++], data: 'nickname', orderable: false,
                                                    render: function (value) {
                                                        return value;
                                                    }
                                                },
                                                {
                                                    targets: [columnNo++], data: 'create_date', orderable: false,
                                                    render: function (value) {
                                                        return value;
                                                    }
                                                },
                                                {
                                                    targets: [columnNo++], data: 'login_date', orderable: false,
                                                    render: function (value) {
                                                        return value;
                                                    }
                                                },
                                                {
                                                    targets: [columnNo++], data: 'login_ip', orderable: false,
                                                    render: function (value) {
                                                        return value;
                                                    }
                                                },
                                                {
                                                    targets: [columnNo++], data: 'id', orderable: false,
                                                    createdCell: function (td, value, item) {
                                                        $(td).html('');
                                                        $(td).append(`<button type='button' class='btn btn-success btn-sm m-2'>${strings.detail}</button>`)
                                                            .find('button')
                                                            .on('click', function () {
                                                                self.showManagerDetailPopup(item.id);
                                                            });
                                                        $(td).append(`<button type='button' class='btn btn-danger btn-sm m-2'>${strings.delete}</button>`)
                                                            .find('button:last')
                                                            .on('click', function () {
                                                                self.deleteManager(item.id);
                                                            });
                                                    }
                                                },
                                            ],
                                            order: [[1, 'DESC']],
                                            ajax: {
                                                url: 'manager/getList',
                                                data: function (req) {
                                                    req.columns = null;
                                                    const searchQS = queryString.parse(self.props.location.search);
                                                    req.start = searchQS.start || 0;
                                                    req.length = searchQS.length || 20;
                                                    req.column = searchQS.column;
                                                    req.keyword = searchQS.keyword;
                                                }
                                            },
                                            drawCallback: function () {
                                            },
                                            fnCreatedRow: function (row, data, dataInd) {
                                            }
                                        }}>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>{strings.user_id}</th>
                                                <th>{strings.nickname}</th>
                                                <th>{strings.create_date}</th>
                                                <th>{strings.login_date}</th>
                                                <th>{strings.ip}</th>
                                                <th>{strings.manage}</th>
                                            </tr>
                                        </thead>
                                        <tbody />
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </PanelBody>
                </Panel>
            </div>
        )
    }
}

export default withRouter(inject('rootStore')(Manager));